import React, { useRef, useEffect, useState } from 'react';
import mapboxgl from 'mapbox-gl';
import axios from 'axios'

// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;

mapboxgl.accessToken =
  'pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4M29iazA2Z2gycXA4N2pmbDZmangifQ.-g_vE53SD2WrJ6tFX7QHmA';

const MapsComponent = (props) => {
  const mapContainerRef = useRef(null);

  const [lng, setLng] = useState(-2.5879);
  const [lat, setLat] = useState(51.4545);
  const [zoom, setZoom] = useState(10);
  const [ logInTime, setLogInTime ] = useState('')
  const [ logInDate, setLogInDate ] = useState('')

  // Initialize map when component mounts
  useEffect(() => {
    axios.get('https://geolocation-db.com/json/344ec440-6bfc-11eb-a0c0-b5dee9e67313').then( response => {
      if (response.status === 200) {
        const map = new mapboxgl.Map({
          container: mapContainerRef.current,
          style: 'mapbox://styles/mapbox/streets-v11',
          center: [response.data.longitude, response.data.latitude],
          zoom: zoom
        });
    
        // Add navigation control (the +/- zoom buttons)
        map.addControl(new mapboxgl.NavigationControl(), 'top-right');
    
        map.on('move', () => {
          setZoom(map.getZoom().toFixed(2));
        });
    
        // Clean up on unmount
        return () => map.remove();
      }
    })
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // handle changing the lat and long
  useEffect( () => {
    if (lng && lat) {
      const map = new mapboxgl.Map({
        container: mapContainerRef.current,
        style: 'mapbox://styles/mapbox/streets-v11',
        center: [lng, lat],
        zoom: zoom
      });
  
      // Add navigation control (the +/- zoom buttons)
      map.addControl(new mapboxgl.NavigationControl(), 'top-right');
  
      map.on('move', () => {
        setZoom(map.getZoom().toFixed(2));
      });
  
      // Clean up on unmount
      return () => map.remove();
    }
  }, [lng, lat])

    useEffect( () => {
      if (props.longitude !== 0) {
        setLng(props.longitude)
        setLat(props.latitude)
      }
      if (props.logInDate !== '') {
        setLogInDate(props.logInDate)
        setLogInTime(props.logInTime)
      }
    }, [props])

  return (
    <div>
      <div className='sidebarStyle'>
        <div>
          Zoom: {zoom} | Log In Time: {logInTime} | Date: {logInDate}
        </div>
      </div>
      <div className='map-container' ref={mapContainerRef} />
    </div>
  );
};

export default MapsComponent;